import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function About(){
  return(
    <section style={{marginTop:50}}>
    <h1 style={{fontWeight: 'bold', color: '#0116D5'}}>About Me</h1>
    <Container style={{marginTop:50}}>
    <Row>
      <Col xs={12} md={8}>
        <h5 style={{textAlign: 'justify', marginTop:'60'}}>Hey folks! My name is Priyanka Roy, currently pursuing B. Tech in Information Technology.
        I'm a Graphic Designer| Ui Designer| Freelancer| Illustrator based in India with 1.5 years of experience.
        At present, I'm working with Red Reef Pixel Ltd, as a Graphic Designer which is a UK based company.
        Also, I've worked as a Graphic designer in Desire Foundation, a govt reg. trust.</h5>
        <br/><h5 style={{textAlign: 'justify'}}>Besides that, I know C++, Java, HTML, CSS.
        As a designer, I work with Adobe Illustrator, Adobe Photoshop, Adobe XD and Adobe InDesign. As well as I'm a Content Writer and a Dancer. 
If you're up for some good projects feel free to contact me.</h5>
      </Col>
      <Col xs={12} md={4}>
        <img src="./images/avatar.jpg" style={{width : '100%', borderRadius: 20}}/>
      </Col>
    </Row>
  </Container>
  </section>
  )
}
export default About;
